import styled from '@emotion/styled';

const CustomInputLabel = styled.label(({ theme }) => ({
    ...theme.typography.p,
    color: theme.colors.common.text,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: theme.spacing.s,
    input: {
        maxWidth: '70px'
    }
}));

const CustomInput = styled.input(({ theme }) => ({
    ...theme.typography.pBold,
    color: theme.colors.common.text,
    border: `1px solid ${theme.colors.common.lightBackground}`,
    borderRadius: theme.borderRadius.s,
    marginTop: theme.spacing.xxs,
    padding: `${theme.spacing.xxxs} ${theme.spacing.xxs}`,
    outline: 'none',
    backgroundColor: theme.colors.common.lightBackground,
    '&:placeholder': {
        color: theme.colors.grey.main,
        opacity: 0.5
    },
    '&:focus, &:active': {
        borderColor: theme.colors.primary.dark
    }
}));

const InfoText = styled.div(({ theme }) => ({
    ...theme.typography.pTiny,
    color: theme.colors.primary.main,
    marginTop: theme.spacing.xxxs
}));

function Input({ label, placeholder, type, infoText, style, ...otherProps }) {
    return (
        <div>
            <CustomInputLabel>
                {label}
                <CustomInput type={type} placeholder={placeholder} {...otherProps} />
                {infoText ? <InfoText>{infoText}</InfoText> : ''}
            </CustomInputLabel>
        </div>
    );
}

export default Input;
